module.exports = __webpack_public_path__ + "img/2-4.4add00e0.svg";